export default __webpack_public_path__ + "static/Tangle3-06de601b9f6a007775d2361d7964d5d2.jpg";